<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_3"></a>your nutrition<br/><strong>SOLUTION</strong><br/>to a<br/><span class="small1">HEALTHY GUT</span></h1>
<p class="subtitle">a meal-based plan to help prevent and treat constipation, diverticulitis, ulcers, and other common digestive problems</p>
<p class="author"><strong>kimberly a. tessmer, <span class="small">RDN, LD</span></strong></p>
<p class="publisher"><img alt="Images" height="102" src="images/pub.jpg" width="438"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5ca582d1